// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Flashcards Section */
.flashcards-section {
  min-height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.generate-flashcards-button {
  background: #667eea;
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 600;
  transition: all 0.3s ease;
  margin-top: 1rem;
}

.generate-flashcards-button:hover:not(:disabled) {
  background: #5a6fd8;
  transform: translateY(-2px);
}

.generate-flashcards-button:disabled {
  background: #ccc;
  cursor: not-allowed;
  transform: none;
}

.flashcard-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 1rem;
}

.retry-button {
  background: #28a745;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 120px;
}

.retry-button:hover:not(:disabled) {
  background: #218838;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
}

.retry-button:disabled {
  background: #ccc;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.flashcards-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  padding: 2rem;
}

.flashcards-empty {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
  color: #94a3b8;
  font-size: 1.125rem;
}

.flashcard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 1rem;
}

.flashcard-progress {
  color: #94a3b8;
  font-size: 1rem;
}

.generate-new-button {
  background: #28a745;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.generate-new-button:hover:not(:disabled) {
  background: #218838;
  transform: translateY(-1px);
}

.generate-new-button:disabled {
  background: #6c757d;
  cursor: not-allowed;
  transform: none;
}

.flashcard {
  width: 600px;
  height: 300px;
  perspective: 1000px;
  cursor: pointer;
}

.flashcard-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.6s;
  transform-style: preserve-3d;
  border-radius: 1rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.flashcard.is-flipped .flashcard-inner {
  transform: rotateY(180deg);
}

.flashcard-front,
.flashcard-back {
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background-color: rgba(31, 41, 55, 0.5);
  border: 1px solid rgba(75, 85, 99, 0.3);
  border-radius: 1rem;
}

.flashcard-back {
  transform: rotateY(180deg);
  background-color: rgba(37, 99, 235, 0.1);
}

.flashcard-content {
  font-size: 1.25rem;
  color: #e2e8f0;
  line-height: 1.6;
  overflow-y: auto;
  max-height: 100%;
  padding: 1rem;
}

.flashcard-controls {
  display: flex;
  gap: 1rem;
}

.control-button {
  padding: 0.75rem 1.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #e2e8f0;
  background-color: rgba(55, 65, 81, 0.5);
  border: 1px solid rgba(75, 85, 99, 0.3);
  border-radius: 0.5rem;
  cursor: pointer;
  transition: background-color 0.2s ease;
  -webkit-user-select: none;
          user-select: none;
}

.control-button:hover:not(:disabled) {
  background-color: rgba(55, 65, 81, 0.7);
}

.control-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Custom Scrollbar for Content */
.flashcard-content::-webkit-scrollbar {
  width: 4px;
}

.flashcard-content::-webkit-scrollbar-track {
  background: rgba(55, 65, 81, 0.3);
  border-radius: 2px;
}

.flashcard-content::-webkit-scrollbar-thumb {
  background: rgba(107, 114, 128, 0.5);
  border-radius: 2px;
}

/* Loading States */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  gap: 1rem;
  color: #94a3b8;
  font-size: 1rem;
}

.loading-spinner {
  display: none;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.no-content {
  text-align: center;
  padding: 3rem;
  color: #666;
}

.no-content p {
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
  color: white;
}

.no-content small {
  color: #999;
}

/* Remove the keyboard navigation hints */
.flashcard-controls::after {
  display: none;
}

.flashcard-controls:hover::after {
  display: none;
}

/* Progress Indicator */
.flashcard-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  height: 3px;
  background: linear-gradient(90deg, #667eea, #28a745);
  border-radius: 1.5px;
  transition: width 0.3s ease;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .flashcard {
    width: 100%;
    height: 250px;
  }

  .flashcard-content {
    font-size: 1rem;
  }

  .flashcard-controls {
    flex-wrap: wrap;
    gap: 0.5rem;
  }
  
  .control-button {
    padding: 0.6rem 1rem;
    font-size: 0.9rem;
    min-width: 100px;
  }
  
  .flashcard-header {
    flex-direction: column;
    text-align: center;
    gap: 0.75rem;
  }
}

@media (max-width: 480px) {
  .flashcard-content {
    padding: 1rem;
    margin: 1rem 0;
  }

  .flashcard-controls {
    gap: 0.5rem;
    flex-direction: column;
  }

  .control-button {
    padding: 0.5rem 0.75rem;
    font-size: 0.9rem;
    width: 100%;
    max-width: 200px;
  }

  .flashcard-buttons {
    flex-direction: column;
    align-items: center;
    gap: 0.75rem;
  }

  .retry-button,
  .generate-flashcards-button {
    width: 100%;
    max-width: 280px;
  }
  
  .flashcard-header {
    margin-bottom: 15px;
  }
  
  .flashcard-progress {
    font-size: 13px;
    padding: 6px 12px;
  }
  
  .generate-new-button {
    font-size: 13px;
    padding: 6px 12px;
  }
}

/* Accessibility improvements */
.control-button:focus {
  outline: 2px solid #667eea;
  outline-offset: 2px;
}

.flashcard-content:focus-within {
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.3);
}

/* High contrast mode support */
@media (prefers-contrast: high) {
  .flashcard-content {
    border: 2px solid #333;
  }
  
  .control-button {
    border: 2px solid transparent;
  }
  
  .control-button:hover:not(:disabled) {
    border-color: #fff;
  }
}

/* Reduced motion support */
@media (prefers-reduced-motion: reduce) {
  .flashcard-inner {
    transition: none;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/VideoTabs/FlashcardsTab.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,4BAA4B;EAC5B,mBAAmB;EACnB,iFAAiF;AACnF;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,uCAAuC;EACvC,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,uCAAuC;EACvC,uCAAuC;EACvC,qBAAqB;EACrB,eAAe;EACf,sCAAsC;EACtC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA,yCAAyC;AACzC;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,oDAAoD;EACpD,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;EACd;AACF;;AAEA;EACE;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;IACjB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;EACd;;EAEA;;IAEE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA,+BAA+B;AAC/B;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;AAChD;;AAEA,+BAA+B;AAC/B;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* Flashcards Section */\n.flashcards-section {\n  min-height: 400px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.generate-flashcards-button {\n  background: #667eea;\n  color: white;\n  border: none;\n  padding: 1rem 2rem;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 1rem;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  margin-top: 1rem;\n}\n\n.generate-flashcards-button:hover:not(:disabled) {\n  background: #5a6fd8;\n  transform: translateY(-2px);\n}\n\n.generate-flashcards-button:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.flashcard-buttons {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  flex-wrap: wrap;\n  margin-top: 1rem;\n}\n\n.retry-button {\n  background: #28a745;\n  color: white;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 1rem;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 120px;\n}\n\n.retry-button:hover:not(:disabled) {\n  background: #218838;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);\n}\n\n.retry-button:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.flashcards-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2rem;\n  padding: 2rem;\n}\n\n.flashcards-empty {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 300px;\n  color: #94a3b8;\n  font-size: 1.125rem;\n}\n\n.flashcard-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.flashcard-progress {\n  color: #94a3b8;\n  font-size: 1rem;\n}\n\n.generate-new-button {\n  background: #28a745;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.generate-new-button:hover:not(:disabled) {\n  background: #218838;\n  transform: translateY(-1px);\n}\n\n.generate-new-button:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.flashcard {\n  width: 600px;\n  height: 300px;\n  perspective: 1000px;\n  cursor: pointer;\n}\n\n.flashcard-inner {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  transition: transform 0.6s;\n  transform-style: preserve-3d;\n  border-radius: 1rem;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n}\n\n.flashcard.is-flipped .flashcard-inner {\n  transform: rotateY(180deg);\n}\n\n.flashcard-front,\n.flashcard-back {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  backface-visibility: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  background-color: rgba(31, 41, 55, 0.5);\n  border: 1px solid rgba(75, 85, 99, 0.3);\n  border-radius: 1rem;\n}\n\n.flashcard-back {\n  transform: rotateY(180deg);\n  background-color: rgba(37, 99, 235, 0.1);\n}\n\n.flashcard-content {\n  font-size: 1.25rem;\n  color: #e2e8f0;\n  line-height: 1.6;\n  overflow-y: auto;\n  max-height: 100%;\n  padding: 1rem;\n}\n\n.flashcard-controls {\n  display: flex;\n  gap: 1rem;\n}\n\n.control-button {\n  padding: 0.75rem 1.5rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #e2e8f0;\n  background-color: rgba(55, 65, 81, 0.5);\n  border: 1px solid rgba(75, 85, 99, 0.3);\n  border-radius: 0.5rem;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  user-select: none;\n}\n\n.control-button:hover:not(:disabled) {\n  background-color: rgba(55, 65, 81, 0.7);\n}\n\n.control-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Custom Scrollbar for Content */\n.flashcard-content::-webkit-scrollbar {\n  width: 4px;\n}\n\n.flashcard-content::-webkit-scrollbar-track {\n  background: rgba(55, 65, 81, 0.3);\n  border-radius: 2px;\n}\n\n.flashcard-content::-webkit-scrollbar-thumb {\n  background: rgba(107, 114, 128, 0.5);\n  border-radius: 2px;\n}\n\n/* Loading States */\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n  gap: 1rem;\n  color: #94a3b8;\n  font-size: 1rem;\n}\n\n.loading-spinner {\n  display: none;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.no-content {\n  text-align: center;\n  padding: 3rem;\n  color: #666;\n}\n\n.no-content p {\n  font-size: 1.1rem;\n  margin-bottom: 0.5rem;\n  color: white;\n}\n\n.no-content small {\n  color: #999;\n}\n\n/* Remove the keyboard navigation hints */\n.flashcard-controls::after {\n  display: none;\n}\n\n.flashcard-controls:hover::after {\n  display: none;\n}\n\n/* Progress Indicator */\n.flashcard-header::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 3px;\n  background: linear-gradient(90deg, #667eea, #28a745);\n  border-radius: 1.5px;\n  transition: width 0.3s ease;\n}\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n  .flashcard {\n    width: 100%;\n    height: 250px;\n  }\n\n  .flashcard-content {\n    font-size: 1rem;\n  }\n\n  .flashcard-controls {\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n  \n  .control-button {\n    padding: 0.6rem 1rem;\n    font-size: 0.9rem;\n    min-width: 100px;\n  }\n  \n  .flashcard-header {\n    flex-direction: column;\n    text-align: center;\n    gap: 0.75rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .flashcard-content {\n    padding: 1rem;\n    margin: 1rem 0;\n  }\n\n  .flashcard-controls {\n    gap: 0.5rem;\n    flex-direction: column;\n  }\n\n  .control-button {\n    padding: 0.5rem 0.75rem;\n    font-size: 0.9rem;\n    width: 100%;\n    max-width: 200px;\n  }\n\n  .flashcard-buttons {\n    flex-direction: column;\n    align-items: center;\n    gap: 0.75rem;\n  }\n\n  .retry-button,\n  .generate-flashcards-button {\n    width: 100%;\n    max-width: 280px;\n  }\n  \n  .flashcard-header {\n    margin-bottom: 15px;\n  }\n  \n  .flashcard-progress {\n    font-size: 13px;\n    padding: 6px 12px;\n  }\n  \n  .generate-new-button {\n    font-size: 13px;\n    padding: 6px 12px;\n  }\n}\n\n/* Accessibility improvements */\n.control-button:focus {\n  outline: 2px solid #667eea;\n  outline-offset: 2px;\n}\n\n.flashcard-content:focus-within {\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.3);\n}\n\n/* High contrast mode support */\n@media (prefers-contrast: high) {\n  .flashcard-content {\n    border: 2px solid #333;\n  }\n  \n  .control-button {\n    border: 2px solid transparent;\n  }\n  \n  .control-button:hover:not(:disabled) {\n    border-color: #fff;\n  }\n}\n\n/* Reduced motion support */\n@media (prefers-reduced-motion: reduce) {\n  .flashcard-inner {\n    transition: none;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
